import React, { useCallback, useState } from 'react'
import styles from './commentItem.module.css'
import { CommentItemHeader } from './components/commentItemHeader/commentItemHeader.index'
import { CommentItemContent } from './components/commentItemContent/commentItemContent.index'
import { CommentItemFooter } from './components/commentItemFooter/commentItemFooter.index'
import { CommentItemSaveData } from '../../commentSection.models'
import { CommentItemType, PendingFile } from '../../../../../../createEscalation.models'
import { useAddEscalationComment } from './commentItem.hooks'
import { Spin } from 'antd'
import { IEscalationComments, IEscalationFiles } from '../../../../../../../../Models/applicationModels'
import { isTypeDraftComment, isTypeEmailSent } from './commentItem.utils'


interface CommentItemProps {
    type: CommentItemType;
    title: string;
    status: string | null ;
    content: string | null;
    files: IEscalationFiles[] | null;
    createdBy: string | null;
    createdAt: string | null;
    onCancel: () => void;
    opportunityUid: string;
    applicationEscalationUid: string;
    setCommentItems: (items: IEscalationComments[]) => void;
    initialStatus: string | null;
    isCommentEmailSend: boolean;
}

export const CommentItem = (props: CommentItemProps) => {
    const { type, title, status, content, files, createdBy, createdAt, onCancel, opportunityUid, applicationEscalationUid, setCommentItems, initialStatus, isCommentEmailSend } = props;
    const { addEscalationComment } = useAddEscalationComment();

    const [pendingFiles, setPendingFiles] = useState<PendingFile[]>([])
    const [addCommentContent, setAddCommentContent] = useState(content ?? "");
    const [isSaving, setIsSaving] = useState(false);
    const [updateInEmailThread, setUpdateInEmailThread] = useState(false);

    const onRemovePendingFile = useCallback((id: string) => {
        setPendingFiles((prev) => prev.filter((f) => f.id !== id))
    }, [])

    const handleSave = useCallback(async () => {
        if (!isTypeDraftComment(type) || !opportunityUid || !applicationEscalationUid || (pendingFiles.length === 0 && !addCommentContent)) return;
        setIsSaving(true);
        try {
            const commentPayload: CommentItemSaveData = {
                commentType: CommentItemType.COMMENT_ADDED,
                comment: addCommentContent,
                files: pendingFiles.map((f: PendingFile) => f.file),
                opportunityUid: opportunityUid,
                applicationEscalationUid: applicationEscalationUid ?? '',
                escalationStatus: initialStatus ?? '',
                updateInEmailThread: updateInEmailThread
            }
            await addEscalationComment(commentPayload, setCommentItems);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSaving(false);
        }
    }, [type, addCommentContent, pendingFiles, opportunityUid, applicationEscalationUid, addEscalationComment, setCommentItems, updateInEmailThread]);

    const showContent = (isTypeDraftComment(type) || (content || files && files.length > 0)) && !isTypeEmailSent(type);

    return (
        <Spin spinning={isSaving}>
            <div className={styles.commentItemContainer}>
                <CommentItemHeader title={title} type={type} status={status} pendingFiles={pendingFiles} setPendingFiles={setPendingFiles} />
                {showContent && <CommentItemContent type={type} content={isTypeDraftComment(type) ? addCommentContent : content} onContentChange={isTypeDraftComment(type) ? setAddCommentContent : undefined} files={files} pendingFiles={pendingFiles} onRemovePendingFile={onRemovePendingFile} />}
                <CommentItemFooter type={type} createdBy={createdBy} createdAt={createdAt} onCancel={onCancel} onSave={handleSave} updateInEmailThread={updateInEmailThread} setUpdateInEmailThread={setUpdateInEmailThread} isCommentEmailSend={isCommentEmailSend} />
            </div>
        </Spin>
    )
}
